<template>
  <!-- 吸底, 自己的一列 -->
  <q-section v-bind="$attrs" :bg-i="mineRank.bg" :key="`mine-${mineRank}`">
    <q-section v-for="(item, index) in [mineRank]" wh="100%" p="relative" :key="`mine-${index}`">
      <DoubleUsers
        :user1="item.user1"
        :user2="item.user2"
        :show-user1="item.showUser1"
        :show-user2="item.showUser2"
        v-bind="item.avatarPosition"
        @avatar-click="handleAvatarClick"
        user-size="44" />
      <q-section v-bind="item.nicknamePosition" p="relative" class="text-nowrap flex flex-col">
        <q-section v-if="item.showUser1" p="relative">{{ item.user1?.nickname }}</q-section>
        <q-section v-if="item.showUser2" p="relative">{{ item.user2?.nickname }}</q-section>
        <q-section p="relative">{{ item.unit }}{{ item[item.scoreType] }}</q-section>
      </q-section>
      <q-section v-bind="item.rankPosition" class="flex flex-row justify-center items-center">
        {{ item.isInRank ? item.rank : '-' }}
      </q-section>
      <q-section
        :bg-i="item.mineBtnBg"
        :key="`mine-btn-${item.mineBtnBg}`"
        v-bind="item.mineBtnPosition"
        @click="handleClick({})"></q-section>
    </q-section>
  </q-section>
</template>

<script setup lang="ts">
import DoubleUsers from './double-users.vue'
const props = defineProps<{
  mineRank: any
}>()

const emit = defineEmits<{
  (e: 'avatarClick', userId: number): void
  (e: 'click', data: any): void
}>()

const handleAvatarClick = (userId: number) => {
  emit('avatarClick', userId)
}

const handleClick = (data: any) => {
  emit('click', data)
}
</script>

<style scoped lang="scss">
.ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
